export function formatTimestamp(timestamp) {
  const date = new Date(timestamp * 1000000); // Преобразуем секунды в миллисекунды
  const day = date.getDate().toString().padStart(2, '0'); // Получаем день
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Получаем месяц (считается с 0, поэтому добавляем 1)
  const year = date.getFullYear(); // Получаем год

  return `${day}/${month}/${year}`;
}
